// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hp-container {
  background-color: black;
  height: 24px;
  margin-bottom: 12px;
  border-radius: 12px;
  width: 80%;
  overflow: hidden;
  border: 3px solid black;
  display: flex;
  align-items: center;
}

.hp-current {
  height: 18px;
  border-radius: 9px;
  transition: width 0.1s ease;
}

.hp-text {
  background-color: black;
  font-weight: 700;
  font-size: 12px;
  color: white;
  padding: 5px 5px;
  border-radius: 55px 55px 10px 10px;
  width: 60%;
  text-align: center;
}

.dungeon-stage-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.dungeon-title {
  opacity: 0.5;
  font-size: 14px;
  margin-top: 2px;
}

.damage-container {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.damage-text {
  position: fixed;
  font-optical-sizing: auto;
  font-weight: 400;
  font-size: 20px;
  text-shadow: 1px 1px 2px black;
  color: rgb(255, 255, 255);
  display: flex;
  align-items: center;
  animation: flyUp 3s ease-out;
  pointer-events: none; /* Чтобы текст не перехватывал клики */
  z-index: 1;
}

@keyframes flyUp {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  5% {
    opacity: 1;
  }
  80% {
    opacity: 1;
    transform: translateY(-120px);
  }
  100% {
    opacity: 0;
    transform: translateY(-120px);
  }
}

.enemy-in {
  animation: moving 0.5s ease;
}

@keyframes moving {
  0% {
    transform: translateY(0px) translateX(0px);
    opacity: 1;
  }
  50% {
    transform: translateY(-40px) translateX(200px);
    opacity: 0;
  }
  100% {
    transform: translateY(0px) translateX(0px);
    opacity: 1;
  }
}

.loot-container {
  background-color: rgba(0, 0, 0, 0.856);
  position: absolute;
  width: 100%;
  top: 0;
  max-width: 500px;
  height: 100%;
  z-index: 8;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.loot-items-list {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  background-color: rgb(61, 61, 61);
  width: 80%;
  padding: 8px;
  border-radius: 14px;
  border: 4px groove rgb(202, 146, 73);
  gap: 5px;
}
.loot-items-info {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  background-color: rgba(61, 61, 61, 0.795);
  width: 80%;
  padding: 8px;
  border-radius: 14px;
  gap: 5px;
}

.loot-item-container {
  position: relative;
  background-color: #222222;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  text-align: center;
  flex-direction: column;
  align-items: center;
  padding: 4px;
  gap: 4px;
  font-size: 10px;
}

.loot-item-text {
  height: 100%;
  width: 100%;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #3f3f3f;
  padding: 4px;
}
.dungeon-rooms-container {
  width: 100%;
  height: 24px;
  display: flex;
  gap: 6px;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
}

.dungeon-room {
  width: 10px;
  height: 10px;
  background-color: rgb(131, 131, 131);
  border-radius: 9px;
}
.dungeon-room-boss {
  width: 10px;
  height: 10px;
  background-color: rgb(206, 95, 31);
  border-radius: 9px;
}

.dungeon-room-boss-active {
  width: 18px;
  height: 18px;
  background-color: rgb(206, 95, 31);
  border-radius: 9px;
}
.dungeon-room-active {
  width: 18px;
  height: 18px;
  background-color: rgb(207, 207, 207);
  border-radius: 9px;
}

.dungeon-info-container {
  position: absolute;
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 30%;
  z-index: 5;
  animation: dunInfoPopup 0.2s ease;
}
@keyframes dunInfoPopup {
  0% {
    opacity: 0;
    scale: 0.8;
  }

  100% {
    opacity: 1;
    scale: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/DungeonStyles.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,oBAAoB,EAAE,sCAAsC;EAC5D,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,6BAA6B;EAC/B;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,0CAA0C;IAC1C,UAAU;EACZ;EACA;IACE,8CAA8C;IAC9C,UAAU;EACZ;EACA;IACE,0CAA0C;IAC1C,UAAU;EACZ;AACF;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,iCAAiC;EACjC,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,QAAQ;AACV;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,yCAAyC;EACzC,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,UAAU;EACV,iCAAiC;AACnC;AACA;EACE;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,QAAQ;EACV;AACF","sourcesContent":[".hp-container {\r\n  background-color: black;\r\n  height: 24px;\r\n  margin-bottom: 12px;\r\n  border-radius: 12px;\r\n  width: 80%;\r\n  overflow: hidden;\r\n  border: 3px solid black;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.hp-current {\r\n  height: 18px;\r\n  border-radius: 9px;\r\n  transition: width 0.1s ease;\r\n}\r\n\r\n.hp-text {\r\n  background-color: black;\r\n  font-weight: 700;\r\n  font-size: 12px;\r\n  color: white;\r\n  padding: 5px 5px;\r\n  border-radius: 55px 55px 10px 10px;\r\n  width: 60%;\r\n  text-align: center;\r\n}\r\n\r\n.dungeon-stage-container {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.dungeon-title {\r\n  opacity: 0.5;\r\n  font-size: 14px;\r\n  margin-top: 2px;\r\n}\r\n\r\n.damage-container {\r\n  position: absolute;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  overflow: hidden;\r\n}\r\n\r\n.damage-text {\r\n  position: fixed;\r\n  font-optical-sizing: auto;\r\n  font-weight: 400;\r\n  font-size: 20px;\r\n  text-shadow: 1px 1px 2px black;\r\n  color: rgb(255, 255, 255);\r\n  display: flex;\r\n  align-items: center;\r\n  animation: flyUp 3s ease-out;\r\n  pointer-events: none; /* Чтобы текст не перехватывал клики */\r\n  z-index: 1;\r\n}\r\n\r\n@keyframes flyUp {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateY(-20px);\r\n  }\r\n  5% {\r\n    opacity: 1;\r\n  }\r\n  80% {\r\n    opacity: 1;\r\n    transform: translateY(-120px);\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: translateY(-120px);\r\n  }\r\n}\r\n\r\n.enemy-in {\r\n  animation: moving 0.5s ease;\r\n}\r\n\r\n@keyframes moving {\r\n  0% {\r\n    transform: translateY(0px) translateX(0px);\r\n    opacity: 1;\r\n  }\r\n  50% {\r\n    transform: translateY(-40px) translateX(200px);\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    transform: translateY(0px) translateX(0px);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.loot-container {\r\n  background-color: rgba(0, 0, 0, 0.856);\r\n  position: absolute;\r\n  width: 100%;\r\n  top: 0;\r\n  max-width: 500px;\r\n  height: 100%;\r\n  z-index: 8;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.loot-items-list {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(0, 1fr));\r\n  background-color: rgb(61, 61, 61);\r\n  width: 80%;\r\n  padding: 8px;\r\n  border-radius: 14px;\r\n  border: 4px groove rgb(202, 146, 73);\r\n  gap: 5px;\r\n}\r\n.loot-items-info {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(0, 1fr));\r\n  background-color: rgba(61, 61, 61, 0.795);\r\n  width: 80%;\r\n  padding: 8px;\r\n  border-radius: 14px;\r\n  gap: 5px;\r\n}\r\n\r\n.loot-item-container {\r\n  position: relative;\r\n  background-color: #222222;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  text-align: center;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding: 4px;\r\n  gap: 4px;\r\n  font-size: 10px;\r\n}\r\n\r\n.loot-item-text {\r\n  height: 100%;\r\n  width: 100%;\r\n  border-radius: 4px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: #3f3f3f;\r\n  padding: 4px;\r\n}\r\n.dungeon-rooms-container {\r\n  width: 100%;\r\n  height: 24px;\r\n  display: flex;\r\n  gap: 6px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-top: 8px;\r\n}\r\n\r\n.dungeon-room {\r\n  width: 10px;\r\n  height: 10px;\r\n  background-color: rgb(131, 131, 131);\r\n  border-radius: 9px;\r\n}\r\n.dungeon-room-boss {\r\n  width: 10px;\r\n  height: 10px;\r\n  background-color: rgb(206, 95, 31);\r\n  border-radius: 9px;\r\n}\r\n\r\n.dungeon-room-boss-active {\r\n  width: 18px;\r\n  height: 18px;\r\n  background-color: rgb(206, 95, 31);\r\n  border-radius: 9px;\r\n}\r\n.dungeon-room-active {\r\n  width: 18px;\r\n  height: 18px;\r\n  background-color: rgb(207, 207, 207);\r\n  border-radius: 9px;\r\n}\r\n\r\n.dungeon-info-container {\r\n  position: absolute;\r\n  width: 100%;\r\n  max-width: 500px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  top: 30%;\r\n  z-index: 5;\r\n  animation: dunInfoPopup 0.2s ease;\r\n}\r\n@keyframes dunInfoPopup {\r\n  0% {\r\n    opacity: 0;\r\n    scale: 0.8;\r\n  }\r\n\r\n  100% {\r\n    opacity: 1;\r\n    scale: 1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
